const VALID_URL_PATTERN = /^(https?:\/\/|data:image\/|blob:)/i;

export function isValidImageUrl(value) {
  return typeof value === "string" && VALID_URL_PATTERN.test(value.trim());
}

// Prefers an absolute imageUrl, otherwise thumbUrl/image; if none are
// absolute, returns the first non-empty value so local assets still work.
export function resolveImageUrl(item) {
  const candidates = [item?.imageUrl, item?.thumbUrl, item?.image];
  const valid = candidates.find(isValidImageUrl);
  return valid ?? candidates.find((c) => typeof c === "string" && c) ?? "";
}